import { useBoolean } from '..';
import useEventListener from '../useEventListener';

var useFocusWithin = function useFocusWithin(target, options) {
  var _useBoolean = useBoolean(false),
      isFocusWithin = _useBoolean.state,
      setIsFocusWithin = _useBoolean.toggle;

  var _ref = options || {},
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange;

  useEventListener('focusin', function (e) {
    if (!isFocusWithin) {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
      onChange === null || onChange === void 0 ? void 0 : onChange(true);
      setIsFocusWithin(true);
    }
  }, {
    target: target
  });
  useEventListener('focusout', function (e) {
    if (isFocusWithin) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      onChange === null || onChange === void 0 ? void 0 : onChange(false);
      setIsFocusWithin(false);
    }
  }, {
    target: target
  });
  return isFocusWithin;
};

export default useFocusWithin;